.#{$namespace}-dropdown-item {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 7px 16px;
	font-size: calc(#{$font-size} - 2px);
	color: $text-primary-color;
	list-style: none;
	cursor: pointer;
	outline: none;

	&__icon {
		font-size: $font-size;
	}

	&:hover {
		color: color-token(primary);
		background-color: color-token(primary, light-8);
	}

	&.is-disabled {
		cursor: not-allowed;
		color: $text-disabled-color;
		background-color: transparent;

		&:hover {
			color: $text-disabled-color;
			background-color: transparent;
		}
	}

	&.is-divided {
		margin-top: 6px;
		border-top: 1px solid $border-color;
	}

	&--large {
		padding: 9px 16px;
		font-size: $font-size;
	}

	&--small {
		padding: 5px 12px;
		font-size: calc(#{$font-size} - 4px);
	}
}
